import { Component, Prop, Vue } from "vue-property-decorator";
import ImgFetched from "@/components/ImgFetched/ImgFetched.vue";
@Component({
  components: {
    ImgFetched
  }
})
class HeadersCommon extends Vue {
  @Prop()
  private ctx: any;
  @Prop({
    default: ""
  })
  private icon?: string;
  @Prop({
    default: ""
  })
  private picUrl?: string;

  private wrappeStyle = `
    width:100px;
    height:100px;
    background:rgb(247,248,250);
    border-radius:50%;
    position:relative;
    margin:0 auto;
  `;

  private picStyle = `
  width:68px;
  height:68px;
  border-radius:50%;
  position:absolute;
  left:50%;
  top:50%;
  transform:translate(-50%,-50%);
  `;

  private iconStyle = `
  width:32px;
  height:32px;
  position:absolute;
  right:0;
  bottom:0;
  `;

  public render() {
    return (
      <div style={this.wrappeStyle}>
        <img-fetched src={this.picUrl} style={this.picStyle} img-kind="user" />

        {this.icon && <img  src={this.icon} style={this.iconStyle} />}
      </div>
    );
  }
}

export default HeadersCommon;
